export const documentLibraryOrgPermissions = {
    /**
     * can open and see (read) directories/documents
     * where such permissions are added by admin
     */
    'view-documents': {
        group: 'Document Library',
        label: 'View Documents',
    },
    /**
     * can open and see (read) and manipulate (write/modify)
     * directories/documents where such permissions are added by admin
     */
    'manage-documents': {
        group: 'Document Library',
        label: 'Manage Documents',
    },
};
